import { Component, onMount } from "solid-js"
import { hasCloud } from "../../lib/core/has_cloud"
import { StateMapDisk } from "../../lib/core/state/state_map_disk.enum"
import { hasIndexedDB } from "../../lib/core/Storage/IndexedDB/hasIndexedDB"
import { disableElement, enableElement } from "../../lib/jsx/disabled"

interface Props {
  value: StateMapDisk
  onChange: (value: StateMapDisk) => void
}

const SelectStateMapDisk: Component<Props> = (props) => {
  const hasIndexedDBFeature = hasIndexedDB()
  const actualOptions = [
    ...(hasIndexedDBFeature ? [<option value={StateMapDisk.IndexedDB}>IndexedDB (Offline)</option>] : []),
    ...(hasCloud ? [<option value={StateMapDisk.Cloud}>Cloud</option>] : []),
    ...(import.meta.env.DEV ? [<option value={StateMapDisk.Workspace}>Workspace (Dev)</option>] : []),
  ]
  if (!actualOptions.length) {
    throw new Error('No storage disks available; IndexedDB, Cloud, or Workspace required')
  }
  const options = [
    ...actualOptions,
    <option value={StateMapDisk.Export} disabled title="Future file save/load">
      Export (Future file save/load)
    </option>,
  ]

  return <select
    ref={(elem) => {
      function onDisabledChanged() {
        if (actualOptions.length > 1) {
          if (elem) {
            enableElement(elem)
          }
        } else if (elem) {
          disableElement(elem)
        }
      }
      onMount(onDisabledChanged)
    }}
    class="form-control"
    name="disk"
    value={props.value}
    onInput={(event: InputEvent) => {
      const selectedValue = ((event.target as HTMLSelectElement)?.value) as StateMapDisk
      // setSelectedValue(selectedValue);
      props.onChange(selectedValue)
    }}
  >
    {options}
  </select>
}

export default SelectStateMapDisk
